import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { uuid, formatCostPrice } from 'utils/common';
import { withStyles } from '@material-ui/core/styles';
import StarIcon from '@material-ui/icons/Star';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import * as _ from 'lodash';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import LocalHotelIcon from '@material-ui/icons/LocalHotel';

class StayCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentImageIndex: 0,
      maxDots: 5,
    };
  }

  nextImage = () => {
    const { maxDots } = this.state;
    const { itineraryPart } = this.props;
    const length = Math.min(itineraryPart.stayData?.images?.length || 1, maxDots);
    this.setState((prevState) => ({
      currentImageIndex: (prevState.currentImageIndex + 1) % length,
    }));
  };

  prevImage = () => {
    const { maxDots } = this.state;
    const { itineraryPart } = this.props;
    const length = Math.min(itineraryPart.stayData?.images?.length || 1, maxDots);
    this.setState((prevState) => ({
      currentImageIndex: (prevState.currentImageIndex - 1 + length) % length,
    }));
  };

  render() {
    const { onViewGallery, classes } = this.props;
    const { currentImageIndex, maxDots } = this.state;
    const { itineraryPart } = this.props;

    const totalImages = itineraryPart.stayData?.images?.length || 0;
    const showDots = Math.min(totalImages, maxDots);

    return (
      <div className={classes.cardContainer}>
        {/* Left Section - Image Gallery */}
        <div
          role="button"
          tabIndex={0}
          className={classes.imageGallery}
          style={itineraryPart.stayData?.images?.length > 0 ? {
            backgroundImage: `url("${encodeURI(itineraryPart.stayData?.images?.[currentImageIndex])}")`,
          } : {}}
          onClick={() => {
            if (onViewGallery && itineraryPart.stayData?.images?.length > 0) {
              onViewGallery(itineraryPart.stayData.images, currentImageIndex);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              if (onViewGallery && itineraryPart.stayData?.images?.length > 0) {
                onViewGallery(itineraryPart.stayData.images, currentImageIndex);
              }
            }
          }}
        >
          {(!itineraryPart.stayData?.images || itineraryPart.stayData?.images?.length === 0) && (
            <div className={classes.noImagePlaceholder}>
              <LocalHotelIcon className={classes.hotelIcon} />
            </div>
          )}

          {/* Navigation arrows - only show if multiple images */}
          {totalImages > 1 && (
            <>
              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  this.prevImage();
                }}
                className={classes.navButtonLeft}
              >
                <ChevronLeftIcon className={classes.navIcon} />
              </button>

              <button
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                  this.nextImage();
                }}
                className={classes.navButtonRight}
              >
                <ChevronRightIcon className={classes.navIcon} />
              </button>

              {/* Pagination dots - limited to 5 */}
              <div className={classes.paginationDots}>
                {Array.from({ length: showDots }, (dot, index) => (
                  <div
                    key={`dot-${index}`}
                    className={index === (currentImageIndex % showDots) ? classes.dotActive : classes.dotInactive}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        {/* Right Section - Hotel Details */}
        <div className={classes.detailsSection}>
          {/* Hotel name and stars */}
          <div className={classes.hotelHeader}>
            <h3 className={classes.hotelName}>
              {itineraryPart.stayData.stayName}
            </h3>
            <div className={classes.starsContainer}>
              {Array.from({ length: itineraryPart.stayData.starRating }, (star, index) => (
                <StarIcon
                  style={{ fontSize: 14, marginTop: 2 }}
                  key={`star-${itineraryPart.stayData.name}-${index}`}
                  className={classes.starIcon}
                />
              ))}
            </div>
          </div>

          {/* Rating badge */}
          {/* <div className={classes.ratingBadge}>
            {typeof itineraryPart.stayData.rating === 'number' ? itineraryPart.stayData.rating.toFixed(1) : itineraryPart.stayData.rating}/5 Rating
          </div> */}
          <div className={classes.bookingInfo}>              
            <InfoOutlinedIcon style={{ fontSize: 12, marginTop: 2 }} />
            Booking is subject to availability            
          </div>

          {/* Location */}
          <div className={classes.locationContainer}>
            <LocationOnIcon className={classes.locationIcon} />
            <span className={classes.locationText}>
              {itineraryPart.stayData.shortAddress}
            </span>
          </div>

          <div className={classes.bottomSection}>
            {/* Details list from API */}
            <div className={classes.detailsList}>
              {
                _.flattenDeep((itineraryPart.stayData.details || []).map((detail, index1) => {
                  return _.concat((detail || []).map((d, index2) => {
                    return (
                      <div
                        key={uuid()}
                        className={index2 === 0 ? classes.detailItemBold : classes.detailItemNormal}
                        style={(index1 > 0 && index2 === 0) ? { marginTop: 10 } : null}
                      >
                        {d}
                      </div>
                    );
                  }));
                }))
              }
            </div>
            {
              (itineraryPart.costPrice || itineraryPart.manualCostPrice) > 0
                ? (
                  <div className={classes.priceValid}>
                    {
                      (itineraryPart.manualCostPrice > 0)
                        ? formatCostPrice(itineraryPart.manualCostPrice)
                        : formatCostPrice(itineraryPart.costPrice, itineraryPart.fxCostPrice, itineraryPart.fxCode)
                    }
                  </div>
                )
                : (
                  <div className={classes.priceMissing}>
                    PRICE MISSING
                  </div>
                )
            }
          </div>
        </div>
      </div>
    );
  }
}

const styles = (theme) => ({
  cardContainer: {
    height: 'auto',
    backgroundColor: theme.colors.white,
    borderRadius: 12,
    boxShadow: '0px 1px 3px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15)',
    display: 'flex',
    overflow: 'hidden',
    fontFamily: 'Sofia-pro, sans-serif',
  },
  imageGallery: {
    width: 267,
    height: 'auto',
    position: 'relative',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    cursor: 'pointer',
  },
  noImagePlaceholder: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  hotelIcon: {
    fontSize: 120,
    color: theme.colors.border,
  },
  navButtonLeft: {
    position: 'absolute',
    left: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
    },
  },
  navButtonRight: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)',
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.95)',
    },
  },
  navIcon: {
    fontSize: 20,
    color: theme.colors.black,
  },
  paginationDots: {
    position: 'absolute',
    bottom: 16,
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    gap: 3,
  },
  dotActive: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: theme.colors.white,
    border: 'none',
  },
  dotInactive: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: 'transparent',
    border: `0.5px solid ${theme.colors.white}`,
  },
  detailsSection: {
    flex: 1,
    padding: '24px 24px 24px 24px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    textAlign: 'left',
    position: 'relative',
  },
  hotelHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  hotelName: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#32302C',
    margin: 0,
  },
  starsContainer: {
    marginLeft: 10,
    display: 'flex',
    alignItems: 'center',
    gap: 4,
  },
  starIcon: {
    fontSize: 12,
    color: theme.colors.yellow,
  },
  ratingBadge: {
    display: 'inline-block',
    backgroundColor: theme.colors.primary,
    color: theme.colors.white,
    fontSize: 14,
    fontWeight: 400,
    padding: '5px 12px',
    borderRadius: 4,
    marginBottom: 8,
  },
  bookingInfo: {
    fontSize: 12,
    display: 'flex',
    alignItems: 'center',
    gap: '5px',
    marginBottom: 8,
    padding: '2px 10px',
    height: 24,
    color: theme.colors.primary,
    backgroundColor: theme.colors.primaryLight, // 15% opacity on cyan
    borderRadius: 4,
  },
  locationContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 4,
    marginBottom: 8,
  },
  locationIcon: {
    marginTop: 2,
    marginRight: 5,
    fontSize: 14,
    color: theme.colors.primary,
  },
  locationText: {
    fontSize: 14,
    color: theme.colors.textLight,
  },
  bottomSection: {
    borderTop: `1px solid ${theme.colors.border}`,
    paddingTop: 10,
    display: 'flex',
    justifyContent: 'space-between',    
    width: '100%',
  },
  detailsList: {
    fontSize: 14,
    color: theme.colors.textLight,
    fontWeight: 400,
  },
  detailItemNormal: {
    fontWeight: 'normal',
  },
  detailItemBold: {
    fontWeight: 'bold',
  },
  priceValid: {
    fontSize: 14,
    fontWeight: 400,
    height: '100%',
    paddingBottom: 16,
    display: 'flex',
    color: theme.colors.green,
    alignItems: 'flex-end',
  },
  priceMissing: {
    fontSize: 14,
    fontWeight: 400,
    height: '100%',
    paddingBottom: 16,
    display: 'flex',
    color: theme.colors.red,
    alignItems: 'flex-end',
  },
});

StayCard.propTypes = {
  itineraryPart: PropTypes.shape({
    stayData: PropTypes.shape({
      stayName: PropTypes.string,
      reviewRating: PropTypes.number,
      starRating: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      shortAddress: PropTypes.string,
      details: PropTypes.arrayOf(
        PropTypes.arrayOf(PropTypes.string)
      ),
      images: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.string,
      stars: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      location: PropTypes.string,
      costPrice: PropTypes.number,
      manualCostPrice: PropTypes.number,
      fxCostPrice: PropTypes.number,
      fxCode: PropTypes.string,
    }),
    costPrice: PropTypes.number,
    manualCostPrice: PropTypes.number,
    fxCostPrice: PropTypes.number,
    fxCode: PropTypes.string,
  }),
  onViewGallery: PropTypes.func,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(StayCard);
